// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"ca0fa916","91":"33d299df"}[chunkId] + ".chunk.js";
};